type SpacerProps = {
  width: number;
  height: number;
  horizontal?: boolean;
}

const Spacer = ({ width, height, horizontal }: SpacerProps) => {
  return (
    <div
      style={
        horizontal
          ? { width: width, height: height, display: 'inline-block', flexShrink: 0 }
          : { width: width, height: height, flexShrink: 0  }
      }
    />
  )
}

export default Spacer;